import { put, takeLatest } from 'redux-saga/effects';

import { requestFloorList } from '../../../services/floor';
import { fetchFloorListFailure, fetchFloorListRequest, fetchFloorListSuccess } from '../../reducers/floor';

export function* watchFloorSaga() {
  yield takeLatest(fetchFloorListRequest, fetchFloorList);
}

/**
 *
 * @param {*} param0
 */
function* fetchFloorList({ payload }) {
  try {
    const response = yield requestFloorList(payload);
    yield put(fetchFloorListSuccess(response));
  } catch (error) {
    yield put(fetchFloorListFailure('Failed to get list of Leads'));
  }
}
